<template>
    <div class="main_body">
        {{listdelete}}
        <div class="input_search mb-4">
            <input v-model="model_find" @keypress.enter="findname" type="text" placeholder="Search" class="form-control">
            <svg @click="findname" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
            </svg>
        </div>
        <Control
            v-bind:add="true"
            v-bind:move="true"
            v-bind:del="true"
            :category_id="category_id"
            :listdelete = "listdelete"
        />        
        <persons-list
            :model_find_prop= "model_find"            
            :category_id_prop = "category_id"
        />
    </div>
</template>

<script>
import {bus} from '../../bus';
import axios from 'axios';
import Dotscontrol from '../Dotscontrol';
import iconsort from "../iconsort";
import PersonsList from './PersonsList.vue';
import Control from './Control.vue';
export default {
    props: [
        'title_person',
        'category_id',
        'base_url'
    ],
    data(){
        return{
            data: {},
            persons: [],            
            model_all: false,
            model_counitempage: 10,
            model_find: '',
            listdelete: [],
            personsIds: [],
            symbolsDescrNumLimit: 200
        }
    },
    methods: {
        findname(){
            // this.getPersons();
            console.log('parent find name fire');
            bus.$emit('getListPerson');
        },
        movePersons(){
            bus.$emit('openpopup', {
                'title_form': 'Move persons',
                'open': true,
                'type': 'moveperson',                
                'personsIds': this.personsIds
            });
        },
        addPerson(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formperson',
                'crud': 'create',
                'title_form': 'Add person to '+ this.title_person,
                'category_id': Number(this.category_id),
                'person': {
                    "first_name": "",
                    "last_name": "",
                    "email": "",
                    "info": "",
                    "link": "",
                    "category_id": Number(this.category_id),
                    "faces": []
                }
            });
        },                
        deletePerson(id){
            // alert(id);
            axios.delete('/persons/'+id).then((responce) => {
                console.log(responce);
                //this.getPersons();
                bus.$emit('getListPerson');
            }).catch((error) => {
                console.log('error delete person', error);
            });
        },                     
        deletePersonCheck(){
            this.listdelete.map((item) => {
                this.deletePerson(item);
            });
            this.listdelete = [];
            this.personsIds = [];
        }
    },
    mounted(){        
        bus.$on('addperson', (data) => {
            let token = document.head.querySelector('meta[name="csrf-token"]'),
                formData = new FormData();
            for( var i = 0; i < data.files.length; i++ ){
                let file = data.files[i];
                formData.append('files[' + i + ']', file);
            }
            delete data.files;
            for( let prop in data ){
                formData.append(prop, data[prop]);
            }
            formData.append('category_id', this.category_id );
            axios.post(
                '/persons',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': token.content
                    }
                }
            )
            .then(function (response) {
                console.log('handle success', response.data);
                this.data.push(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

        });        
        bus.$on('changeSelectPersons', (data) => {
            if(data){
                this.listdelete = data.listdelete;
                this.personsIds = data.personsIds;
                console.log('this.personsIds from parent: ', this.personsIds);
                console.log('this.listdelete from parent: ', this.listdelete);
            }
        })        
    },
    components: {      
        Control,
        Dotscontrol,
        iconsort,
        PersonsList
    }
}
</script>

<style scoped>
    .pagination {
     flex-wrap: wrap;   
    }
    
    .table-list .table-list-row {
        grid-template-columns: 5fr 100px 3fr 205px;
    }
    .table-list-row__description {
        padding: 0 5px;
    }
</style>
